export interface GetImageParamsOptions {
  imageSize?: string
  width?: number
  height?: number
  index: number
  debug?: boolean
}

export interface ImageParamsResult {
  size: string
  padding: string
  exar: string
}

/**
 * Generates both padding and size parameters for an image.
 */
export function getImageParams(
  {
    imageSize = 'M standaard',
    width = 1500,
    height = 1500,
    index = 1,
    debug = false,
  }: GetImageParamsOptions): ImageParamsResult {
  // Only the first image uses its own imageSize; others default to xl
  if (index !== 1) {
    imageSize = 'XL'
  }

  const sizeConfig: Record<string, { top: number, bottom: number, side: number }> = {
    'XS': { top: 0.15, bottom: 0.023, side: 0.15 },
    'S': { top: 0.1, bottom: 0.023, side: 0.1 },
    'M standaard': { top: 0.05, bottom: 0.023, side: 0.075 },
    'L': { top: 0.025, bottom: 0.023, side: 0.05 },
    'XL': { top: 0.01, bottom: 0.023, side: 0.025 },
  }

  const cfg = sizeConfig[imageSize || 'XL'] || sizeConfig['XL']

  const topPadding = Math.round(height * cfg.top)
  const bottomPadding = Math.round(height * cfg.bottom)
  const sidePadding = Math.round(width * cfg.side)

  let resizedWidth = width - 2 * sidePadding
  let resizedHeight = height - topPadding - bottomPadding

  resizedWidth += width - (resizedWidth + 2 * sidePadding)
  resizedHeight += height - (resizedHeight + topPadding + bottomPadding)

  resizedWidth = Math.round(resizedWidth)
  resizedHeight = Math.round(resizedHeight)

  const size = `f=rs:fit:${resizedWidth}:${resizedHeight}:0:0`
  const padding = `pd:${topPadding}:${sidePadding}:${bottomPadding}:${sidePadding}`
  const exar = `exar:1:so:0:0`

  if (debug) {
    console.log('--- Image Params Debug ---')
    console.log('index:', index)
    console.log('imageSize:', imageSize)
    console.log('padding:', padding)
    console.log('size:', size)
    console.log('exar:', exar)
  }

  return { size, padding, exar }
}
